import React from "react";
import EngageCard from "./card/EngageCard";
import "./Engage.css";
import { ACH, BB, Chantel, HomeMent } from "../../images/images";
import HorizontalScroll from "../../components/HorizontalScroll/HorizontalScroll";
import { navigateTo } from "../../utils/navigateTo";
import "../../components/HorizontalScroll/HorizontalScroll.css";

// Custom yellow card component
const YellowEngageCard: React.FC = () => (
  <div className="engage-card-wrapper">
    <div className="engage-card engage-card--yellow">
      <div className="engage-card-yellow-content">
        <span className="engage-card-yellow-title">
          Meet Minister Chantal Ekabe
        </span>
        <ul className="engage-card-yellow-list">
          <li>Commander</li>
          <li>Warrior</li>
          <li>Prophet</li>
          <li>Intercessor</li>
          <li>Teacher</li>
          <li>Writer</li>
          <li>Evangelist</li>
        </ul>
      </div>
      <button
        onClick={() => navigateTo("/chantal")}
        className="engage-card-yellow-btn"
      >
        View More
      </button>
    </div>
  </div>
);

const engageItems = [
  {
    image: Chantel,
    title: "Chantal Ekabe",
    link: "/chantal",
  },
  {
    image: BB,
    title: "Our Beliefs",
    link: "/beliefs",
  },
  {
    image: HomeMent,
    title: "Mentorship",
    link: "https://launcher.nucleus.church/launcher/4f6c8b56bda9dab3c8ef/flow/48f5a3019e9c7b1ec4ac",
  },
];

const Engage: React.FC = () => {
  return (
    <section className="engage-section">
      <h2 className="engage-header">Engage With Us</h2>
      <HorizontalScroll showArrows={true} showArrowsOnDesktop={false}>
        <YellowEngageCard />
        {engageItems.map((item, idx) => (
          <EngageCard
            key={idx}
            image={item.image}
            title={item.title}
            link={item.link}
          />
        ))}
      </HorizontalScroll>
    </section>
  );
};

export default Engage;
